const shareInitialState = {
  open:    false,
  link:    '',
  loading: false,
};

export default shareInitialState;